import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';

@Component({
  selector: 'brt-svg-highlight',
  templateUrl: './svg-highlight.component.html',
  styleUrls: ['./svg-highlight.component.scss']
})
export class SvgHighlightComponent implements OnInit, AfterViewInit {

  @ViewChild('mainEl') mainEl!: ElementRef;
  svgType = -1;

  @Input('state') set setState(val: boolean) {
    this.state = val;

    if(val) {
      this.playAnimation();
    }
  }

  state = false;
  private readonly NUMBER_OF_SVGS = 8;
  isReady = false;

  ngOnInit() {
    // must be set before the template is first checked, otherwise ngSwitch throws ExpressionChangedAfterItHasBeenCheckedError
    this.svgType = Math.floor(Math.random() * this.NUMBER_OF_SVGS);
  }

  ngAfterViewInit() {
    window.requestAnimationFrame(() => {
      this.prepareAnimation();

      window.requestAnimationFrame(() => {
        if(this.state) {
          this.playAnimation();
        }
      });


    });


  }

  prepareAnimation() {
    if(this.mainEl) {
      const htmlEl = this.mainEl.nativeElement as HTMLElement;

      const pathEl = htmlEl.querySelector("path");

      if(pathEl) {
        const pathLength = Math.ceil(pathEl.getTotalLength());

        pathEl.style.strokeDasharray = `${pathLength}`;
        pathEl.style.strokeDashoffset = `${pathLength}`;

        window.requestAnimationFrame(() => {
          this.isReady = true;
        });
      }
    }
  }

  playAnimation() {
    if(this.mainEl) {
      const htmlEl = this.mainEl.nativeElement as HTMLElement;
      const pathEl = htmlEl.querySelector("path");
      if(pathEl) {
        pathEl.style.strokeDashoffset = `0`;
      }
    }
  }


}
